import React from 'react';
import Checkbox from '@alltrails/shared/components/checkboxes/Checkbox24';
import * as styles from '../../columns/SelectedColumn/styles/styles.module.scss';

type SelectedTrailsColumnHeaderProps = {
  getToggleAllPageRowsSelectedProps: () => { onChange: (e: React.ChangeEvent<HTMLInputElement>) => void };
};

const SelectedTrailsColumnHeader = ({ getToggleAllPageRowsSelectedProps }: SelectedTrailsColumnHeaderProps): JSX.Element => {
  const { onChange } = getToggleAllPageRowsSelectedProps();
  // Placeholder for tooltip from TOOLS-567
  const labelComponent: JSX.Element = null;
  return (
    <Checkbox id="select-all" className={styles.selectCell} labelComponent={labelComponent} name="" checked={false} value="" onChange={onChange} />
  );
};

export default SelectedTrailsColumnHeader;
